import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { GraphQlService } from '@shared/services/graphql-service';
import { ApolloNamespace } from '@shared/enums/apollo-namespaces';
import { GET_MY_ROLE_OPEN_TASKS_QUERY } from '../graphql/external-authenticated-layout.graphql';
import { WorkflowTaskType } from '@shared/components/notifications/notification';
import { OpenTasksActions } from './external-auth.actions';

type MyOpenTasksResponse = {
  myOpenTasks?: WorkflowTaskType[] | null;
};

@Injectable()
export class ExternalAuthEffects {
  private readonly actions$ = inject(Actions);
  private readonly graphqlService = inject(GraphQlService);

  loadMyOpenTasks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OpenTasksActions.request),
      switchMap(() =>
        this.graphqlService
          .query<MyOpenTasksResponse>({
            query: GET_MY_ROLE_OPEN_TASKS_QUERY,
            apolloNamespace: ApolloNamespace.workflow,
          })
          .pipe(
            map((response) =>
              OpenTasksActions.success({ response: response.data?.myOpenTasks ?? [] }),
            ),
            catchError((error) => of(OpenTasksActions.failure({ error }))),
          ),
      ),
    ),
  );
}
